import gsap from 'gsap';
import CountTo from 'vue-count-to';

export default {
  components: {
    CountTo
  },
  data: {
    loaderInitialized: false,
    loaderIsActive: true,
    loaderPercentageOld: 0,
    loaderPercentage: 15,
    loaderCountDuration: 2000,
    timelineHide: gsap.timeline({
      paused: true
    }),
    timelineShow: gsap.timeline({
      paused: true
    }).addLabel('start').timeScale(1.7)
  },
  methods: {
    hideLoader() {
      return new Promise((resolve) => {
        const checkPageReady = () => {
          if (this.$store.state.pageReady) {
            this.timelineHide.restart().eventCallback("onComplete", () => {
              this.loaderIsActive = false;
              resolve();
            })
            window.cancelAnimationFrame(checkPageReady);
          } else {
            window.requestAnimationFrame(checkPageReady);
          }
        }

        window.requestAnimationFrame(checkPageReady)
      })
    },
    showLoader() {
      this.loaderIsActive = true;

      return new Promise((resolve) => {
        this.timelineShow.restart().eventCallback("onComplete", () => {
          resolve();
        });
      });
    },
    setLoaderPercentage(value) {
      this.loaderPercentageOld = this.loaderPercentage;

      if (value > this.loaderPercentageOld && value !== this.loaderPercentage) {
        this.loaderPercentageOld = this.loaderPercentage;
        this.loaderPercentage = value;
      }
    }
  },
  mounted() {
    let circleSmall = this.$route.meta.background === '#000' ? '#fff' : "#000";
    const circleBigColor = this.$route.meta.background ? this.$route.meta.background : "#fff";

    this.$refs['circle-small'].children[0].style.backgroundColor = circleSmall;
    this.$refs['circle-small'].children[1].style.color = circleBigColor;
    this.$refs['circle-big'].children[0].style.backgroundColor = circleBigColor;
    this.$refs['circle-half-top'].style.backgroundColor = circleBigColor;
    this.$refs['circle-half-bottom'].style.backgroundColor = circleBigColor;
    this.$refs['circle-half-1'].style.backgroundColor = circleBigColor;
    this.$refs['circle-half-2'].style.backgroundColor = circleBigColor;

    this.timelineHide
      .to([this.$refs['circle-big'], this.$refs['circle-half-wrapper-1'], this.$refs['circle-half-wrapper-2']], {
        display: 'none'
      })
      .to(this.$refs['circle-small'], {
        display: 'none',
        width: '0px',
        duration: 1,
        ease: 'power2.in',
      })
      .to(this.$refs['text'], {
        opacity: 0,
        duration: 0.8,
        ease: 'power2.in',
        delay: -1
      })
      .to(this.$refs['circle-half-wrapper-main'], {
        opacity: 0,
        // scale: 0,
        // x: "-50%",
        // y: "-50%",
        duration: 0.7,
        ease: 'power1.in',
        delay: -0.3
      })
      .to(this.$refs['page-loader'], {
        display: 'none',
        duration: 1,
        delay: -1
      });

    this.timelineShow
      .to([this.$refs['circle-half-wrapper-1'], this.$refs['circle-half-wrapper-2']], {
        scale: 0,
        x: "-50%",
        y: "-50%",
        rotate: 0,
        duration: 0,
      })
      .to(this.$refs['circle-half-wrapper-main'], {
        scale: 0,
        x: "-50%",
        y: "-50%",
        opacity: 1,
        duration: 0,
      })
      .to(this.$refs['circle-half-bottom'], {
        rotate: -180,
        duration: 0,
      })
      .to([this.$refs['page-loader'], this.$refs['circle-big'], this.$refs['circle-half-wrapper-1'], this.$refs['circle-half-wrapper-2']], {
        display: 'block',
      })
      .to(this.$refs['circle-big'], {
        width: '30%',
        duration: 1,
        ease: "none"
      }, "start")
      .to(this.$refs['circle-small'], {
        display: "block",
        opacity: 1,
        width: this.viewport.width > 576 ? "190px" : "160px",
        duration: 1,
        ease: "none"
      }, "start+=0.4")
      .to(this.$refs['text'], {
        opacity: 1,
        duration: 1,
        ease: "none"
      }, "start+=0.8")
      .to(this.$refs['circle-half-wrapper-main'], {
        scale: 1,
        duration: 1.5,
        ease: "none"
      }, "start+=0.2")
      .to(this.$refs['circle-half-bottom'], {
        rotate: 0,
        duration: 1.5,
        ease: "none"
      }, "start+=0.2")
      .to(this.$refs['circle-half-wrapper-1'], {
        scale: 0.4,
        duration: 0.8,
        ease: "none"
      }, "start+=0.2")
      .to(this.$refs['circle-half-1'], {
        rotate: 180,
        duration: 0.8,
        ease: "none"
      }, "start+=0.2")
      .to(this.$refs['circle-half-wrapper-2'], {
        scale: 0.7,
        duration: 0.8,
        ease: "none"
      }, "start+=0.4")
      .to(this.$refs['circle-half-2'], {
        rotate: 180,
        duration: 0.8,
        ease: "none"
      }, "start+=0.4");

    this.loaderInitialized = true;
  }
}